// This file is auto-generated. Do not modify this file manually.

export const Icons = {
  IQ: 'IQ',
  AcademyLg: 'academyLg',
  AccountRg: 'accountRg',
  Amex: 'amex',
  Applepay: 'applepay',
  ArrowDownRg: 'arrowDownRg',
  ArrowLeftRg: 'arrowLeftRg',
  ArrowRightRg: 'arrowRightRg',
  ArrowUpRg: 'arrowUpRg',
  AwardLg: 'awardLg',
  BasketFilledRg: 'basketFilledRg',
  BasketRg: 'basketRg',
  BellSm: 'bellSm',
  BinSm: 'binSm',
  BulkBuyLg: 'bulkBuyLg',
  BulkBuyNoCircle: 'bulkBuyNoCircle',
  CallRg: 'callRg',
  ChecklistOrder: 'checklistOrder',
  ChecklistLg: 'checklistLg',
  ClinicOrder: 'clinicOrder',
  CloseRg: 'closeRg',
  CloseSm: 'closeSm',
  CollapseSm: 'collapseSm',
  CompanyLg: 'companyLg',
  ContinueLg: 'continueLg',
  CrossXs: 'crossXs',
  DateSm: 'dateSm',
  DeleteCellAction: 'deleteCellAction',
  DeliveredLg: 'deliveredLg',
  DevicesLg: 'devicesLg',
  DirectToPatientLg: 'directToPatientLg',
  DocUploadLg: 'docUploadLg',
  DosageInstructionsSm: 'dosageInstructionsSm',
  DownloadSm: 'downloadSm',
  DropdownSm: 'dropdownSm',
  DtpOrder: 'dtpOrder',
  DuplicateCellAction: 'duplicateCellAction',
  EditCellActon: 'editCellActon',
  EditRg: 'editRg',
  EditSm: 'editSm',
  EditUserLg: 'editUserLg',
  EditUserSm: 'editUserSm',
  EmailLg: 'emailLg',
  ErrorSm: 'errorSm',
  EventsLg: 'eventsLg',
  FacebookSocial: 'facebookSocial',
  FilterAndSortSm: 'filterAndSortSm',
  FlagIRE: 'flagIRE',
  FlagUK: 'flagUK',
  FloatingMenuTopper: 'floatingMenuTopper',
  FourOhFourLg: 'fourOhFourLg',
  GooglePay: 'googlePay',
  HideSm: 'hideSm',
  HxBasicWhiteLogo: 'hxBasicWhiteLogo',
  IcnMiniWarningBlk: 'icnMiniWarningBlk',
  IconPlayMed: 'iconPlayMed',
  InfoSm: 'infoSm',
  InstagramSocial: 'instagramSocial',
  InvoicesLg: 'invoicesLg',
  IssueSm: 'issueSm',
  LinkedinSocial: 'linkedinSocial',
  LocationLg: 'locationLg',
  LockRg: 'lockRg',
  LogoHealthxchangeSmall: 'logoHealthxchangeSmall',
  MailSm: 'mailSm',
  MaintenanceLg: 'maintenanceLg',
  Mastercard: 'mastercard',
  MenuRg: 'menuRg',
  MessagesLg: 'messagesLg',
  MinusSm: 'minusSm',
  MinusXs: 'minusXs',
  MoreRg: 'moreRg',
  MoveToPatientSm: 'moveToPatientSm',
  NoResultsLg: 'noResultsLg',
  NotesLg: 'notesLg',
  OfferLg: 'offerLg',
  OfferOrder: 'offerOrder',
  OrderBuilderRg: 'orderBuilderRg',
  OrderConfirmedLg: 'orderConfirmedLg',
  OrderLg: 'orderLg',
  PatientsLg: 'patientsLg',
  PaymentMastercard: 'paymentMastercard',
  PaymentOptionsCellAction: 'paymentOptionsCellAction',
  PhoneLg: 'phoneLg',
  PhoneSm: 'phoneSm',
  PhotoIdLg: 'photoIdLg',
  PlusRg: 'plusRg',
  PlusSm: 'plusSm',
  PlusXs: 'plusXs',
  ProblemSm: 'problemSm',
  ProductsLg: 'productsLg',
  PurchaseApprove: 'purchaseApprove',
  RefreshRg: 'refreshRg',
  RejectCellAction: 'rejectCellAction',
  ResourcesLg: 'resourcesLg',
  ReviewLg: 'reviewLg',
  RxLg: 'rxLg',
  RxOrder: 'rxOrder',
  SavedLg: 'savedLg',
  SearchRg: 'searchRg',
  SearchSm: 'searchSm',
  ShippingLg: 'shippingLg',
  ShowSm: 'showSm',
  SignCellAction: 'signCellAction',
  SignatureLg: 'signatureLg',
  SignedOrder: 'signedOrder',
  SortRg: 'sortRg',
  StaffUsersLg: 'staffUsersLg',
  StockLg: 'stockLg',
  StockOrder: 'stockOrder',
  SubmitMiniButton: 'submitMiniButton',
  SuccessSm: 'successSm',
  SupportChatLg: 'supportChatLg',
  SupportLg: 'supportLg',
  SupportOrder: 'supportOrder',
  SwitchRg: 'switchRg',
  TechLg: 'techLg',
  TickXs: 'tickXs',
  TiktokSocial: 'tiktokSocial',
  TncsLg: 'tncsLg',
  TrackingCellAction: 'trackingCellAction',
  UnlockCellAction: 'unlockCellAction',
  UpDownArrowSm: 'upDownArrowSm',
  UserLg: 'userLg',
  UserSuccessLg: 'userSuccessLg',
  VideoPlayLg: 'videoPlayLg',
  VideoPlaySm: 'videoPlaySm',
  ViewCellAction: 'viewCellAction',
  Visa: 'visa',
  WaitLg: 'waitLg',
  WarningLg: 'warningLg',
  WarningNoCircle: 'warningNoCircle',
  WarningSm: 'warningSm',
  WarningXs: 'warningXs',
  XSocial: 'xSocial',
  YoutubeSocial: 'youtubeSocial',
} as const;

export type IconsType = (typeof Icons)[keyof typeof Icons];
